import useMap from "../core/utils/useMap";
import { transformObjectToFlat } from "../utils/zone.utils";

/** 
 * @typedef ZoneComputedAction
 * @property {(propName:string, cb: (nextValue:any, currentValue: any) => any) => void} useZoneComputed
*/



const fnDoComputed = (computedCallbacks, propName, nextvalue, currentValue) => {
    let v = nextvalue;
    if (computedCallbacks.has(propName)) {
        v = computedCallbacks.get(propName).call(null, nextvalue, currentValue);
    }
    if (typeof v === 'undefined' && typeof currentValue !== "undefined") {
        console.error(`${propName} return an undefined, must be return a computed value`);
    }
    return v;
}

/**
   * 
   * @returns { ZoneMiddleWare }
   */
const computed = () => {

    const computedCallbacks = useMap();

    /** @type{import("../t.d").ZoneMiddleWare} */
    const middleware = {
        injectTo: 'origin',
        injectProps: () => {
            return Array.from(computedCallbacks.keys())
        },
        provider: {
            getter: (propArr, value) => {
                return value;
            },
            setter: (propArr, nextValue, currentValue) => {
                return fnDoComputed(computedCallbacks, propArr, nextValue, currentValue);
            }
        },
        action: {
            useZoneComputed: (propName, cb) => {
                if (typeof propName === 'object') {
                    const flatObject = transformObjectToFlat(propName);
                    for (let k in flatObject) {
                        const cb = flatObject[k]
                        if (typeof cb !== 'function') {
                            console.error(`[useZoneComputed] The value of ${k} must be a function`);
                            continue;
                        }
                        computedCallbacks.set(k, cb)
                    }
                    return () => {
                        for (let k in flatObject) {
                            computedCallbacks.delete(k);
                        }
                    }
                } else if (typeof cb !== 'function') {
                    throw new Error('2nd arg must be a function');
                }
                computedCallbacks.set(propName, cb);
                return () => {
                    computedCallbacks.delete(propName);
                }
            },
            useZoneHeavyComputed: (propName, cb) => {

            }
        }
    }
    return middleware;
};


export default computed;